import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import "./App.css";
import Home from "./pages/Home/Home";
import Event from "./pages/Event/Event";
import News from "./pages/News/News";
import GalleryAndVideo from "./pages/GalleryAndVideo/GalleryAndVideo";
import EventDetails from "./pages/Event/EventDetails";
import NewsDetails from "./pages/News/NewsDetails";
// import League from "./pages/League/League";
// import Teams from "./pages/Teams/Teams";
import Match from "./pages/Match/Match";
import MatchDetail from "./pages/Match/MatchDetail";
import LeagueList from "./pages/League/LeagueList";
import Sponsors from "./pages/Sponsors/Sponsors";
import SponsorDetail from "./pages/Sponsors/SponsorsDetail";
import AdvertisementDetail from "./pages/Sponsors/AdvertisementDetail";
import Competitions from "./data/competitions";
// import ResultSummary from "./pages/result";
import LeagueTable from "./pages/League/LeagueTable";
import TeamInformation from './pages/Teams/TeamInformation';
import Result from "./pages/Result/Result";
import Manofthematch from "./pages/ManOfTheMatch/ManOfTheMatch";
function App() {
  return (
    <BrowserRouter>
      <div className="app-container">
        <Header />
        <main className="main-content" style={{marginTop: "70px"}}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/event" element={<Event />} />
            <Route path="/event/:id" element={<EventDetails />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetails />} />
            <Route path="/gallery-video" element={<GalleryAndVideo />} />

            {/* League Routes - Fixed */}
            <Route path="/cricket-league" element={<LeagueList />} />
            {/* <Route path="/cricket-league/:id" element={<League />} /> */}

            {/* <Route path="/cricket-team" element={<Teams />} /> */}
            <Route path="/cricket-matches" element={<Match />} />
            <Route path="/cricket-match/:id" element={<MatchDetail />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/sponsor/:id" element={<SponsorDetail />} />
            <Route
              path="/advertisement-detail/:id"
              element={<AdvertisementDetail />}
            />

            <Route path="/competitions" element={<Competitions />} />
            <Route path="/league-table/:divisionId" element={<LeagueTable />} />
            <Route path="/cricket-team/:teamId" element={<TeamInformation />} />

            <Route path="/results" element={<Result/>}/>
            <Route path="/man-of-the-match" element={<Manofthematch/>}/>
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
